import { h, Component } from 'preact';
import { joinClasses, accessNested, sortObjectByOrder } from 'utils/utils';
import { getMovieName } from 'utils/bolt/showtimes';
import { getShowtimesData } from 'utils/bolt';
import Store from 'store/store';
import Tooltip from 'components/bolt/tooltip/tooltip';
import HTML from 'components/core/html/html';
import CalendarEmpty from 'components/bolt/icons/calendarEmpty';
import EmailForm from 'components/bolt/forms/chains/email/form';
import RegalForm from 'components/bolt/forms/chains/regal/form';
import AmcForm from 'components/bolt/forms/chains/amc/form';
import CinemarkForm from 'components/bolt/forms/chains/cinemark/form';
import s from 'components/bolt/forms/groupBookingsInquiry.sss';

export default class GroupBookingsInquiry extends Component {
	constructor(props) {
		super(props);
		const showtimesData = getShowtimesData() || {};
		this.setFormSubmitted = this.setFormSubmitted.bind(this);
		this.chainSlug = this.props.selectedTheater.chain.slug;
		this.groupBookingFormType = this.getGroupBookingFormType();
		this.hasRecaptcha = showtimesData.groupBookings?.enableFormRecaptcha;
		this.recaptchaKey = showtimesData.groupBookings?.recaptchaKey || '6LconT4hAAAAAKKHhv6UlG5RbqAdqXtJvVD3yY0O';
		this.htmlSubmit = showtimesData.groupBookings?.forms?.[`${this.groupBookingFormType}`]?.htmlSubmit;
		this.submitUrl = showtimesData.groupBookings?.forms?.[`${this.groupBookingFormType}`]?.submitUrl || {};
		this.submitToNewTab = showtimesData.groupBookings?.forms?.[`${this.groupBookingFormType}`]?.submitToNewTab || {};
		const stages = sortObjectByOrder(showtimesData.groupBookings?.forms?.[`${this.groupBookingFormType}`]?.stages || {}, (val, key) => ({ ...val, key }));
		const stageIds = stages.map(stage => stage.key);
		const stageTitles = stages.map(stage => stage.title);
		this.finalStage = showtimesData.groupBookings?.forms?.[`${this.groupBookingFormType}`]?.finalStage || 'Check Your Details';
		let fieldsData = {};
		stageIds.forEach(stage => {
			const fields = showtimesData.groupBookings?.forms?.[`${this.groupBookingFormType}`]?.stages?.[stage]?.fields || {};
			const fieldsToAdd = {};
			Object.keys(fields).forEach(fieldName => {
				fieldsToAdd[fieldName] = {
					...fields[fieldName],
					stage,
				};
			});
			fieldsData = {
				...fieldsData,
				...fieldsToAdd
			};
		});
		this.fields = sortObjectByOrder(fieldsData);
		this.stages = [...stageIds, this.finalStage];
		this.stageTitles = [...stageTitles, this.finalStage];
		this.descriptionText = showtimesData.groupBookings?.forms?.[`${this.groupBookingFormType}`]?.formDescriptionText || {};
		this.confirmationText = showtimesData.groupBookings?.forms?.[`${this.groupBookingFormType}`]?.formConfirmationText || {};
		this.invalidNextTimer = showtimesData.groupBookings?.invalidNextTimer || '';
		this.initialStage = this.stages[0];
	}


	getGroupBookingFormType() {
		const showtimesAppData = getShowtimesData() || {};
		if (showtimesAppData.groupBookings?.preselectedForm) {
			return showtimesAppData.groupBookings?.preselectedForm;
		}

		const theaterData = showtimesAppData?.groupBookings?.formsForTheater || {};
		const chainsData = showtimesAppData?.groupBookings?.formsForChain || {};
		const theaterId = this.props?.selectedTheater?.id;
		if (theaterId && theaterData[theaterId]) {
			return theaterData[theaterId];
		}

		const currentChainId = this.props?.selectedTheater?.chain?.id;
		const formForChain = chainsData[currentChainId]?.form;
		return formForChain;
	}

	componentDidUpdate(oldProps) {
		if (this.props.formData?.currentStage !== oldProps.formData?.currentStage) {
			// Ugly - find a better way to handle focusing the first visible field
			this.base?.querySelector('[class*=field__wrapper]:not([class*=hidden]) :is(input:not([type=hidden]), select, textarea, button):not([disabled])')?.focus();
		}
	}

	navigateStages = (action) => {
		const { formData } = this.props;
		const currentStage = formData.currentStage || this.initialStage;
		const currentStageComplete = this.currentStageComplete();
		const currentStageIndex = this.stages.findIndex(stage => stage === currentStage);
		Store.emit('GROUP_BOOKINGS_NAVIGATE_STAGES', action || 'next');
		if (action === 'previous') {
			this.props.onChange('currentStage', this.stages[currentStageIndex - 1]);
			return;
		}

		if (!currentStageComplete) {
			this.$form.validateAll();
		} else {
			this.props.onChange('currentStage', this.stages[currentStageIndex + 1]);
		}
	};
	handleFormSubmission = async (e) => {
		e.preventDefault();
		const currentStageComplete = this.currentStageComplete();

		if (!currentStageComplete) {
			this.$form.validateCaptcha();
		} else {
			Store.emit('GROUP_BOOKINGS_SUBMIT', this.props.selectedTheater);

			this.setState({ submissionLoading: true });

			if (this.htmlSubmit) {
				let formEl = this.$form?.base;
				formEl?.requestSubmit ? formEl.requestSubmit() : formEl?.submit();
				this.setState({ submissionLoading: false });

			} else {
				// FETCH POST
				const formData = new FormData(this.$form?.base);
				let data = {};

				for (let key of formData.keys()) {
					data[key] = formData.get(key);
				}
				const { movieTitle, theaterName } = this.getMovieTitleAndTheater();
				data['startTime'] = `${data['hour']}:${data['minute']} ${data['meridian']}`;
				// get todays date
				if (!this.groupBookingFormType === 'regal-cinemas') {
					data['date'] = new Date().toISOString().slice(0, 10);
				}
				data['chainId'] = this.props.chainId;
				data['film'] = movieTitle;
				data['theaterLocation'] = theaterName;
				delete data['g-recaptcha-response'];
				delete data['currentStage'];

				if (this.groupBookingFormType === 'email-form') {
					const movieId = accessNested(this.props, 'store.appData.pages.boltShowtimes.data.movieId', '');
					const emailTemplateId = accessNested(this.props, 'store.appData.pages.boltShowtimes.data.groupBookings.forms.email-form.emailTemplateId', 'theChosen');
					data['movieId'] = movieId;
					data['templateId'] = emailTemplateId;
				}

				const h = new Headers();
				h.append('Content-type', 'application/json');

				const request = new Request(this.submitUrl, {
					headers: h,
					body: JSON.stringify(data),
					method: 'POST',
					mode: 'cors'
				});

				const response = await fetch(request);
				this.setState({ submissionLoading: false });
				// const response = { ok: true, status: 200 };

				if (!response.ok) {
					this.setState({ renderFormError: true });
				} else {
					// Do we need to check for 201 specifically ? No user feedback otherwise ?
					if (response.status === 200 || response.status === 201) {
						this.setFormSubmitted();
					}
				}
			}
		}
	};

	setFormSubmitted() {
		this.setState({ renderFormSubmitted: true });
	}

	renderFormSubmitted = () => {
		const store = Store.get();
		const copy = store?.appData?.copy?.baseCopy || {};
		const data = {
			content: copy.$FORM_SUBMITTED_CONFIRMATION || 'The theater will be in touch soon!',
			title: copy.$INQUIRY_SENT || 'Inquiry Sent',
			buttonTooltip: copy.$BACK_TO_THEATER || 'Back to theater listing'
		};

		const multipleActions = () => {
			const deviceSize = accessNested(Store.get(), 'client.deviceSize', {});
			const action = deviceSize === 'mobile' ? 'POP_HEADER_ACTION' : 'POP_SHOWTIMES_BTN_ACTION';
			Store.emit(action);
			this.props.goBack();
		};

		return (
			<Tooltip
				ref={ref => this.$tooltip = ref?.base}
				class={s.submittedOverlay}
				data={data}
				isMobile
				isOpen
				position={'topRight'}
				onHide={multipleActions}
				icon={(
					<div className={s.formSubmissionIcon}>
						{/* like CalendarEmpty but with checkmark, need proper svg instead of 2 parts */}
						<svg width="35" height="33" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M18.89 30H5C4.33696 30 3.70107 29.7366 3.23223 29.2678C2.76339 28.7989 2.5 28.163 2.5 27.5V11.5H32.5V16.39C33.4386 16.9378 34.2828 17.6334 35 18.45V5C35 3.67392 34.4732 2.40215 33.5355 1.46447C32.5979 0.526784 31.3261 0 30 0L5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5L0 27.5C0 28.8261 0.526784 30.0979 1.46447 31.0355C2.40215 31.9732 3.67392 32.5 5 32.5H21C20.1656 31.7867 19.4529 30.9424 18.89 30ZM10 2.5H30C30.663 2.5 31.2989 2.76339 31.7678 3.23223C32.2366 3.70107 32.5 4.33696 32.5 5V9H2.5V5C2.5 4.33696 2.76339 3.70107 3.23223 3.23223C3.70107 2.76339 4.33696 2.5 5 2.5H10Z"
								fill="black"
								fill-opacity="0.3"
							/>
						</svg>
						<svg
							className={s.secondaryIcon}
							width="12"
							height="10"
							viewBox="0 0 12 10"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M3.59958 8.79067L1.19877 6.26339C0.933745 5.98406 0.933745 5.53141 1.19877 5.25274C1.46379 4.97342 1.89382 4.97342 2.15884 5.25274L4.07962 7.27604L9.84069 1.2095C10.1063 0.930168 10.5364 0.930168 10.8008 1.2095C11.0664 1.48882 11.0664 1.94281 10.8008 2.22147L4.55965 8.79067C4.42714 8.93 4.25338 9 4.07962 9C3.90585 9 3.73209 8.93 3.59958 8.79067Z"
								fill="black"
							/>
							<path
								d="M3.59958 8.79067L1.19877 6.26339C0.933745 5.98406 0.933745 5.53141 1.19877 5.25274C1.46379 4.97342 1.89382 4.97342 2.15884 5.25274L4.07962 7.27604L9.84069 1.2095C10.1063 0.930168 10.5364 0.930168 10.8008 1.2095C11.0664 1.48882 11.0664 1.94281 10.8008 2.22147L4.55965 8.79067C4.42714 8.93 4.25338 9 4.07962 9C3.90585 9 3.73209 8.93 3.59958 8.79067"
								stroke="black"
							/>
						</svg>
					</div>
				)}
			/>
		);
	};
	renderFormError = () => {
		const store = Store.get();
		const copy = store?.appData?.copy?.baseCopy || {};
		const data = {
			content: copy.$GROUP_BOOKINGS_TRY_AGAIN || 'Try going back to listings to resolve the issue (data is not lost).',
			title: copy.$GROUP_BOOKINGS_FORM_ERROR || 'Oh no! Looks like you encountered an error.',
			buttonTooltip: copy.$BACK_TO_LISTINGS || 'Back to Listings'
		};

		const multipleActions = () => {
			const deviceSize = accessNested(Store.get(), 'client.deviceSize', {});
			const action = deviceSize === 'mobile' ? 'POP_HEADER_ACTION' : 'POP_SHOWTIMES_BTN_ACTION';
			Store.emit(action);
			this.props.goBack('preserveData');
		};

		return (
			<Tooltip
				ref={ref => this.$tooltip = ref?.base}
				class={s.submittedOverlay}
				data={data}
				isMobile
				isOpen
				position={'topRight'}
				onHide={multipleActions}
				icon={(
					<div className={s.formSubmissionIcon}>
						<CalendarEmpty className={s.submissionErrorIcon} />
					</div>
				)
				}
			/>
		);
	};
	getMovieTitleAndTheater = () => {
		const { selectedTheater } = this.props;
		const movieId = accessNested(this.props, 'store.appData.pages.boltShowtimes.data.movieId', '');
		const movieTitle = getMovieName(movieId);
		return {
			movieTitle,
			chainId: selectedTheater?.chainId,
			theaterName: selectedTheater?.name,
			amcName: selectedTheater?.meta?.amcName
		};
	};
	renderTheaterIcon = () => {
		const { selectedTheater, logoShade } = this.props;
		const sharedImageRoot = accessNested(this.props, 'store.appData.urls.roots.sharedImages') || '';
		const logo = accessNested(selectedTheater, 'chain.logo') || 'default.png';

		const logoLink = `${sharedImageRoot}/logos/${logoShade}/${logo}`;
		const accessibilityCopy = accessNested(this.props, 'store.appData.copy.accessibilityCopy', {});
		const strippedChainName = selectedTheater?.chain && selectedTheater?.chain.name.replace(/\..*/, '');
		const isRTL = accessNested(this.props, 'store.appData.styling.fontVariables.textDirection') === 'rtl';
		return (
			<div class={joinClasses(s.icon, isRTL && s.rtlIcon)}>
				<img src={logoLink} alt={accessibilityCopy.$CINEMA_LOGO_ALT.replace('<chain>', strippedChainName)} />
			</div>
		);
	};
	renderMovieInfo = () => {
		const { client, formData } = this.props;
		const { movieTitle, theaterName } = this.getMovieTitleAndTheater();
		const currentStage = formData.currentStage || this.initialStage;
		const currentStageIndex = this.stages.indexOf(currentStage);
		const currentStageTitle = this.stageTitles[currentStageIndex];

		return (
			<div>
				<div className={s.title}>{!client.isDesktopSize && 'Group Booking -'} {currentStageTitle}</div>
				<div className={s.movieDetails}>
					<div class={s.header}>
						{this.renderTheaterIcon()}
						<div class={s.details}>
							<div className={s.movieTitle}>{movieTitle}</div>
							<div className={s.theaterName}>{theaterName}</div>
						</div>
					</div>
				</div>
			</div>
		);
	};
	renderFormDescription = () => {
		const { formData } = this.props;
		const currentStage = formData.currentStage || this.initialStage;

		return (
			<div>
				{currentStage !== this.finalStage &&
					<HTML class={s.description} content={this.descriptionText} markdown />}
				{currentStage === this.finalStage &&
					<HTML class={s.description} content={this.confirmationText} markdown />}
			</div>
		);
	};
	renderForm = () => {
		const { movieTitle, theaterName, chainId, amcName } = this.getMovieTitleAndTheater();
		const theaterCity = this.props.selectedTheater?.address?.intl?.city;
		const { formData } = this.props;
		const currentStage = formData.currentStage || this.initialStage;
		const store = Store.get();
		const copy = store?.appData?.copy?.baseCopy || {};
		// @TODO make this a json array rather than have to split it
		let FormComponent = {
			'amc-theatres': AmcForm,
			'regal-cinemas': RegalForm,
			'cinemark-theatres': CinemarkForm,
			'email-form': EmailForm
		}[this.groupBookingFormType];
		if (!FormComponent) {
			return (
				<HTML
					class={s.unsupported}
					content={copy.$GROUP_BOOKINGS_UNSUPPORTED || 'Group Bookings is not supported yet by this chain/theatre, please come back later.'}
					markdown
				/>
			);
		}

		return (
			<div className={s.outerContainer}>
				{this.renderFormDescription()}
				<div className={s.mainContent}>
					<FormComponent
						formId={this.chainSlug}
						ref={e => this.$form = e}
						fields={this.fields}
						data={this.props.formData}
						currentStage={currentStage}
						finalStage={this.finalStage}
						movieTitle={movieTitle}
						chainId={chainId}
						selectedTheaterCity={theaterCity}
						selectedTheaterName={theaterName}
						submitUrl={this.submitUrl}
						submitToNewTab={this.submitToNewTab}
						onChange={this.props.onChange}
						isValidTime={this.isValidTime}
						hasRecaptcha={this.hasRecaptcha}
						recaptchaKey={this.recaptchaKey}
						htmlSubmit={this.htmlSubmit}
						setFormSubmitted={this.setFormSubmitted}
						amcName={amcName}
					/>
					{this.renderBottomNavigationBar()}
				</div>
			</div>
		);
	};

	renderStages = () => {
		const { formData } = this.props;
		const currentStage = formData.currentStage || this.initialStage;

		return (
			<div className={s.stageSelection}>
				{this.stages.map(stage => {
					const activeStageIndex = this.stages.indexOf(currentStage);
					const stageIndex = this.stages.indexOf(stage);
					let rule;

					if (stageIndex > activeStageIndex) {
						rule = this.isStageComplete(currentStage);
					} else {
						rule = this.isStageComplete(stage);
					}

					const finalRule = stage === this.finalStage ? this.allStagesComplete({ navigationClick: true }) : rule;


					return (
						<div
							className={joinClasses(s.stage, currentStage === stage && s.currentStage, finalRule && s.active)}
							// onClick={() => finalRule && this.setState({ currentStage : stage })}
						>
							{this.stageTitles[stageIndex]}
						</div>
					);
				})}
			</div>
		);
	};

	isValidTime = (time) => {
		if (!time) return;
		const validMeridian = ['AM', 'PM'];
		if (time.hour && time.minute && time.meridian) {
			return Number(time.hour) !== isNaN() && Number(time.minute) !== isNaN() && validMeridian.includes(time.meridian);
		}
	};

	currentStageComplete = () => {
		const { formData } = this.props;
		const currentStage = formData.currentStage || this.initialStage;

		if (currentStage === this.finalStage) {
			if (!this.hasRecaptcha) {
				return true;
			}

			if (!formData?.captcha) return false;
			else return true;
		}

		const result = this.fields
			.filter(field => field.stage === currentStage)
			.map(field => {
				const fieldValue = formData[field.id];
				const regexValidation = new RegExp(field.validation.regex).test(fieldValue);
				const timepickerValidation = this.isValidTime(fieldValue) && regexValidation;

				if (field.required) {
					return fieldValue && (field.type === 'timepicker' ? timepickerValidation : regexValidation);
				} else {
					return fieldValue ? (field.type === 'timepicker' ? timepickerValidation : regexValidation) : true;
				}
			});

		return result.every(item => item === true);
	};

	isStageComplete = (currentStage) => {
		const { formData } = this.props;

		if (currentStage === this.finalStage) {
			return true;
		}

		const result = this.fields
			.filter(field => field.stage === currentStage)
			.map(field => {
				const fieldValue = formData[field.id];
				const regexValidation = new RegExp(field.validation.regex).test(fieldValue);
				const timepickerValidation = this.isValidTime(fieldValue) && regexValidation;

				if (field.required) {
					return fieldValue && (field.type === 'timepicker' ? timepickerValidation : regexValidation);
				} else {
					return fieldValue ? (field.type === 'timepicker' ? timepickerValidation : regexValidation) : true;
				}
			});

		return result.every(item => item === true);
	};
	allStagesComplete = (options) => {
		const { formData } = this.props;
		const navigationClick = options?.navigationClick;

		const result = this.fields.map(field => {
			if (field.required) {
				return formData[field.id] && new RegExp(field.validation.regex).test(formData[field.id]);
			} else {
				return formData[field.id] ? new RegExp(field.validation.regex).test(formData[field.id]) : true;
			}
		});

		if (navigationClick) return result.every(item => item === true);

		if (this.hasRecaptcha) {
			return result.every(item => item === true) && formData.captcha;
		} else {
			return result.every(item => item === true);
		}
	};
	renderBottomNavigationBar = () => {
		const { client, formData } = this.props;
		const currentStage = formData.currentStage || this.initialStage;

		const currentStageComplete = this.currentStageComplete();
		const allStagesComplete = this.allStagesComplete();
		const currentStageIndex = this.fields.findIndex(field => field.stage === currentStage);

		return (
			<div className={s.bottomBar}>
				{currentStageIndex !== 0 && (
					<button onClick={() => this.navigateStages('previous')}>
						{client.isDesktopSize ? 'Previous Page' : 'Back'}
					</button>
				)}
				<div className={joinClasses(s.filler, s.noBg)} key="filler" />
				{currentStage !== this.finalStage && (
					<Tooltip
						ref={ref => this.$completeFieldsTooltip = ref?.base}
						class={s.completeFieldsFirst}
						data={{ content: 'Please complete the required fields first' }}
						selfHideMilliseconds={this.invalidNextTimer}
						showCondition={!currentStageComplete}
						stageIndex={currentStageIndex}
						position="topLeft"
					>
						<button
							id="nextButton"
							ref={e => this.$nextButton = e}
							class={!currentStageComplete && s.disabledButton}
							onClick={() => this.navigateStages()}
						>{client.isDesktopSize ? 'Next Page' : 'Next'}
						</button>
					</Tooltip>

				)}
				{(currentStage === this.finalStage) && (
					<Tooltip
						ref={ref => this.$completeFieldsTooltip = ref?.base}
						class={s.completeFieldsFirst}
						data={{ content: 'Please complete the captcha first' }}
						selfHideMilliseconds={this.invalidNextTimer}
						showCondition={!currentStageComplete}
						stageIndex={currentStageIndex}
						position="topLeft"
					>
						<button
							form={this.chainSlug}
							type="submit"
							onClick={(e) => this.handleFormSubmission(e)}
							disabled={this.state.submissionLoading}
							className={joinClasses(s.submitButton, (!allStagesComplete || this.state.submissionLoading) && s.disabledButton, this.state.submissionLoading && s.spinner)}
						>
							{!this.state.submissionLoading && 'Submit'}
						</button>
					</Tooltip>
				)}
			</div>
		);
	};

	render() {
		const { client } = this.props;
		if (!this.fields) return;

		return (
			<div className={s.eventInquiryContainer}>
				{client.isDesktopSize && this.renderStages()}
				<div className={s.pannels}>
					<div className={s.mainPannel}>
						{this.renderMovieInfo()}
						{this.renderForm()}
						{this.state.renderFormSubmitted && this.renderFormSubmitted()}
						{this.state.renderFormError && this.renderFormError()};
					</div>
				</div>
			</div>
		);
	}
}
